import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-select/dist/css/bootstrap-select.css';
import 'bootstrap-select/dist/js/bootstrap-select';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { ConnectIntlProvider } from './container';

const root = ReactDOM.createRoot(document.getElementById('root'));
import LDProvider from './LDProvider';

root.render(
  <Provider store={store}>
    <ConnectIntlProvider>
      <LDProvider>
        <App />
      </LDProvider>
    </ConnectIntlProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
